import { render, staticRenderFns } from "./UsersDataTable.vue?vue&type=template&id=ed3af988"
import script from "./UsersDataTable.vue?vue&type=script&lang=js"
export * from "./UsersDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports